import React from 'react'

const Error404 = () => (
  <div>
    <p> This is 404 error</p>
  </div>
)

export default Error404
